import React, { Component } from 'react';
import { Form, Card, Drawer, Button, Row, Tabs, Collapse, Col, Icon, notification, DatePicker, Radio, Input, Select, Checkbox, TimePicker } from 'antd';
import _ from 'lodash';
import { FormUtils as GetAllFormFields, TableComp } from 'sz-react-utils';
import { connect } from 'react-redux';
import Request, { API_URL } from '../../../../request';
import styles from './styles.less'
import { each } from 'async';
import moment from 'moment';

const dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : "DD.MM.YYYY"


const { TabPane } = Tabs
const Option = Select.Option;
const { TextArea } = Input
const { Panel } = Collapse
@Form.create()
class ClickToCallDrawer extends Component {
    state = {
        visible: true,
        stage: null,
        callStatus: null,
        ratingArr: [],
        followUpTypesArr: [],
        counsellorArr: [],
        sourceArr: [],
        nextFollowUp: false,
        sendWhatsappMessage: false,
        reassignLead: false,
        loading: false,
        templateArr: [],
        activeTab: '0',
        lastCallData: {},
        timerStart: false,
        hours: 0,
        minutes: 0,
        seconds: 0,
        intervalId: ''
    }

    onClose = () => {
        clearInterval(this.state.intervalId);
        this.setState({ visible: false, hours: 0, minutes: 0, seconds: 0 })
        setTimeout(() => {
            this.props.onClose()
        }, 50)
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let { record } = this.props
            params.sortField = "createdByUser.time"
            params.sortOrder = "DESC"
            params.studentId = record._id
            let response = await Request.getCallDetailsByStudent(params)
            let lastCall = response.data[0]
            this.props.form.setFieldsValue(lastCall)
            if (lastCall && lastCall.stage) {
                this.setState({ lastCallData: response.data[0], callStatus: lastCall && lastCall.callStatus, stage: lastCall.stage })
            } else {
                this.setState({ lastCallData: response.data[0], callStatus: lastCall && lastCall.callStatus })
            }

            return resolve(response)
        })
    }

    loadApis = async () => {
        let params = {
            results: 1000,
            count: 10000
        }
        let ratingResponse = await Request.getRatingsDetails(params);
        let ratingArr = []
        let followUpTypesArr = []
        let sourceArr = []
        let counsellorArr = []
        _.each(ratingResponse.data, (rating) => {
            ratingArr.push({ _id: rating._id, display: rating.ratingName })
        })
        let followUpResponse = await Request.getFollowUpTypes(params);
        _.each(followUpResponse.data, (type) => {
            followUpTypesArr.push({ _id: type.name, display: type.name })
        })
        let sourceResponse = await Request.getSourceDetails(params);
        _.each(sourceResponse.data, (source) => {
            sourceArr.push({ _id: source._id, display: source.sourceName })
        })
        let activeUser = JSON.parse(localStorage.getItem('user'))
        let counsellorResponse = await Request.loadCounsellor({
            results: 10000,
            atLevel: ["Counselling Desk"],
            userBranch: activeUser.userBranch,
            active: true,
            isCounsellor: true
        });
        _.each(counsellorResponse.data, (counsellor) => {
            counsellorArr.push({ _id: counsellor._id, display: counsellor.name })
        })
        this.setState({ ratingArr, followUpTypesArr, sourceArr, counsellorArr })
    }

    loadSmsTemplate = async () => {
        let templateArr = await Request.getTemplatesForCommunication('Whatsapp')
        this.setState({ templateArr })
    }


    startTimer = () => {
        // setInterval(() => {
        //     this.setState((prevState) => ({
        //         seconds:prevState.seconds + 1,
        //       }), ()=>{
        //         let {hours,minutes,seconds} = this.state;
        //         if (seconds > 59) {
        //             minutes += 1;
        //             seconds = 0;
        //         }
        //         if (minutes > 59) {
        //             hours += 1;
        //             minutes = 0;
        //             seconds = 0;
        //         }
        //         this.setState({hours,minutes,seconds});
        //       });
        // }, 1000);
        let intervalId = setInterval(
            () => {
                this.setState((prevState) => ({
                    seconds: prevState.seconds + 1,
                }), () => {
                    let { hours, minutes, seconds } = this.state;
                    if (seconds > 59) {
                        minutes += 1;
                        seconds = 0;
                    }
                    if (minutes > 59) {
                        hours += 1;
                        minutes = 0;
                        seconds = 0;
                    }
                    this.setState({ hours, minutes, seconds });
                });
            }
            , 1000)
        this.setState({ intervalId });
    }

    async componentDidMount() {
        await this.loadApis()
        this.loadSmsTemplate()
        this.startTimer()
    }

    callback = (value) => {
        if (value) {
            this.chooseTab(value)
        }
    }

    chooseTab(value) {
        this.setState({
            activeTab: value
        })
    }


    handleSubmit = (e) => {
        let { form, record } = this.props;
        console.log(record);
        let { counsellorArr, hours, minutes, seconds } = this.state;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            if (!values.callStatus) {
                notification.error({
                    message: 'Choose Call Status'
                })
                return
            }
            values.studentId = record._id;
            values.studentMobile = record.mobile;
            values.studentName = record.studentName;
            values.studentBranchId = record.studentBranchId._id;
            values.id = record.id;
            values.callDuration = `${hours > 9 ? hours : '0' + hours}:${minutes > 9 ? minutes : '0' + minutes}:${seconds > 9 ? seconds : '0' + seconds}`;
            values.type = this.props.type;
            if (values.reassignLead == true && values.counsellorId) {

                let foundCounsellor = counsellorArr.find((obj) => {
                    return obj._id === values.counsellorId
                })
                if (foundCounsellor) {
                    values.counsellorName = foundCounsellor.display;
                }
            }
            console.log(values);
            this.setState({ loading: true })
            let response = await Request.addCallDetail(values);
            this.setState({ loading: false })
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }

            this.onClose()
        })
    }

    render() {
        let { record, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let { visible, hours, minutes, seconds, callStatus, ratingArr, followUpTypesArr, reassignLead, counsellorArr, sourceArr, stage, nextFollowUp, sendWhatsappMessage } = this.state;
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };

        const columns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                width: 80,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Student Name',
                key: 'studentName'
            },
            {
                title: 'V.I.D',
                key: 'id'
            },
            {
                title: 'Interested In',
                key: 'interestedIn'
            },
            {
                title: 'Call Date',
                key: 'callDate',
                render: (text, record) => (
                    <div>{moment(record.callDate).format(dateFormat)}</div>
                )
            },
            {
                title: 'Call Time',
                key: 'callTime',
                render: (text, record) => (
                    <div>{moment(record.callDate).format("HH:mm A")}</div>
                )
            },
            {
                title: 'Call Status',
                key: 'callStatus'
            },
            {
                title: 'Remark',
                key: 'remark'
            }

        ]
        return (
            <Drawer
                title={
                    <div>
                        <p>
                            Call Details:
                            {hours < 10 ? "0" + hours : hours}:{minutes < 10 ? "0" + minutes : minutes}:{seconds < 10 ? "0" + seconds : seconds}
                        </p>
                        {/* <div className="clock-container">
                            <div className="clock-col">
                                <p className="clock-day clock-timer">
                                    {moment().format('dd')}
                                </p>
                                <p className="clock-label">
                                    Day
                                </p>
                            </div>
                            <div className="clock-col">
                                <p className="clock-hours clock-timer">
                                    {hours < 10 ? "0" + hours : hours}
                                </p>
                                <p className="clock-label">
                                    Hours
                                </p>
                            </div>
                            <div className="clock-col">
                                <p className="clock-minutes clock-timer">
                                    {minutes < 10 ? "0" + minutes : minutes}
                                </p>
                                <p className="clock-label">
                                    Minutes
                                </p>
                            </div>
                            <div className="clock-col">
                                <p className="clock-seconds clock-timer">
                                    {seconds < 10 ? "0" + seconds : seconds}
                                </p>
                                <p className="clock-label">
                                    Seconds
                                </p>
                            </div>
                        </div> */}
                        {/* {`Call Details:- ${record.studentName} ${record.countryCode?record.countryCode:"+91"}-${record.mobile}`} */}
                    </div>
                }
                placement="right"
                closable={true}
                width={800}
                onClose={this.onClose}
                visible={this.state.visible} >
                <Card bordered={false}>
                    <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
                        {/* Information Tab */}
                        <TabPane tab={`Student Information`} key={0}>
                            <Row>
                                <Col>
                                    <Collapse accordion defaultActiveKey={['1']}>
                                        <Panel header="Contact History" key={1}>
                                            <TableComp
                                                id={"callReport"}
                                                columns={columns}
                                                ref={this.table}
                                                useFixedHeader={true}
                                                apiRequest={this.apiRequest}
                                                extraProps={{ scroll: { x: 1100 } }}
                                                pagination={{
                                                    showSizeChanger: true,
                                                    defaultPageSize: 5,
                                                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                                                }} />
                                        </Panel>
                                        {/* <Panel header="Lead Information" key={2}>
                            <Card title="Visa Details" bordered={false} className='cardStyle'></Card>
                            </Panel> */}
                                    </Collapse>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Card title="Details" className='mainCardStyle'>
                                        <table width={"100%"}>
                                            <tbody>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Gender</th>
                                                    <th>Mobile No.</th>
                                                    <th>Email ID</th>

                                                </tr>
                                                <tr>
                                                    <td>{record.studentName}</td>
                                                    <td>{record.gender}</td>
                                                    <td>{record.countryCode}{record.mobile}</td>
                                                    <td>{record.emailId ? record.emailId : "N/A"}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Card>
                                </Col>
                            </Row>
                        </TabPane>
                        {/* Action Tab */}
                        <TabPane tab={`Action`} key={1}>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Item>
                                    {getFieldDecorator('callStatus', {
                                        initialValue: this.state.lastCallData && this.state.lastCallData.callStatus ? this.state.lastCallData.callStatus : null
                                    })(
                                        <Radio.Group value={this.state.lastCallData && this.state.lastCallData.callStatus ? this.state.lastCallData.callStatus : null} onChange={(e) => this.setState({ callStatus: e.target.value })} buttonStyle="solid">
                                            <Radio.Button value={"Connected"}>Connected</Radio.Button>
                                            <Radio.Button value={"Not Connected"}>Not Connected</Radio.Button>
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                                {
                                    callStatus === "Connected" ?
                                        <div>
                                            <Form.Item>
                                                <Row style={{ marginTop: 10 }}>
                                                    <Col span={6}>
                                                        <div>
                                                            Service You Interested In?
                                                        </div>
                                                    </Col>
                                                    <Col span={12}>
                                                        {getFieldDecorator('interestedIn', {
                                                            initialValue: this.state.lastCallData && this.state.lastCallData.interestedIn ? this.state.lastCallData.interestedIn : null
                                                        })(
                                                            <Select defaultValue={this.state.lastCallData && this.state.lastCallData.interestedIn ? this.state.lastCallData.interestedIn : null}>
                                                                <Option value={"Study Abroad"}>Study Abroad</Option>
                                                                <Option value={"Tourist Visa"}>Tourist Visa</Option>
                                                                <Option value={"PR"}>PR</Option>
                                                                <Option value={"IELTS/PTE"}>IELTS/PTE</Option>
                                                            </Select>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Form.Item>

                                            <Form.Item>
                                                <Row style={{ marginTop: 10 }}>
                                                    <Col span={6}>
                                                        <div>
                                                            Where Did you Hear About Us?
                                                        </div>
                                                    </Col>
                                                    <Col span={12}>
                                                        {getFieldDecorator('source', {
                                                            initialValue: this.state.lastCallData && this.state.lastCallData.source ? this.state.lastCallData.source : null
                                                        })(
                                                            <Select>
                                                                {sourceArr.map((source) => (
                                                                    <Option key={source._id} value={source.display}>{source.display}</Option>
                                                                ))}
                                                            </Select>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Form.Item>
                                            <Form.Item>
                                                <Row style={{ marginTop: 10 }}>
                                                    <Col span={6}>
                                                        <div>
                                                            Expected Enrollment Date
                                                        </div>
                                                    </Col>
                                                    <Col span={12}>
                                                        {getFieldDecorator('enrollmentDate')(
                                                            <DatePicker defaultValue={this.state.lastCallData && this.state.lastCallData.enrollmentDate ? moment(this.state.lastCallData.enrollmentDate, dateFormat) : null} showTime format="YYYY-MM-DD" />
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Form.Item>
                                            <Form.Item>
                                                <Row style={{ marginTop: 10 }}>
                                                    <Col span={6}>
                                                        <div>
                                                            Stage
                                                        </div>
                                                    </Col>
                                                    <Col span={12}>
                                                        {getFieldDecorator('stage', {
                                                            initialValue: this.state.lastCallData && this.state.lastCallData.stage ? this.state.lastCallData.stage : null
                                                        })(
                                                            <Select value="Open" onChange={(e) => this.setState({ stage: e })}>
                                                                <Option value={'Open'}>Open</Option>
                                                                <Option value={'In Progress'}>In Progress</Option>
                                                                <Option value={'Converted'}>Converted</Option>
                                                                <Option value={'Lost'}>Lost</Option>
                                                            </Select>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Form.Item>
                                            {
                                                stage === "In Progress" ?
                                                    <div>
                                                        <Form.Item>
                                                            <Row style={{ marginTop: 10 }}>
                                                                <Col span={6}>
                                                                    <div>
                                                                        Select Rating
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    {getFieldDecorator('rating', {
                                                                        initialValue: this.state.lastCallData && this.state.lastCallData.rating ? this.state.lastCallData.rating : null
                                                                    })(
                                                                        <Radio.Group value={this.state.lastCallData && this.state.lastCallData.interestedIn && this.state.lastCallData.rating ? this.state.lastCallData.rating : null} required={stage === "In Progress"}>
                                                                            {ratingArr.map((rating) => (
                                                                                <Radio key={rating._id} value={rating._id}>{rating.display}</Radio>
                                                                            ))}
                                                                        </Radio.Group>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Form.Item>

                                                    </div>
                                                    : null
                                            }
                                            {
                                                stage === "Open" || stage === 'In Progress' ?
                                                    <div>
                                                        <Form.Item>
                                                            <Row style={{ marginTop: 10 }}>
                                                                <Col span={6}>
                                                                    <div>
                                                                        Next Follow Up
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    {getFieldDecorator('nextFollowUp')(
                                                                        <Checkbox defaultChecked={this.state.nextFollowUp} onChange={(e) => this.setState({ nextFollowUp: e.target.checked })} />
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Form.Item>
                                                    </div>
                                                    : null
                                            }

                                            {/* Next Follow Up */}
                                            {
                                                nextFollowUp ?
                                                    <div>
                                                        <Form.Item>
                                                            <Row style={{ marginTop: 10 }}>
                                                                <Col span={6}>
                                                                    <div>
                                                                        Next Followup Date
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    {getFieldDecorator('followUpDate')(
                                                                        <DatePicker required={nextFollowUp} showTime format="YYYY-MM-DD" />
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Form.Item>
                                                        <Form.Item>
                                                            <Row style={{ marginTop: 10 }}>
                                                                <Col span={6}>
                                                                    <div>
                                                                        Best Time to Call
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    {getFieldDecorator('followUpTime')(
                                                                        <TimePicker format='HH:mm' />

                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Form.Item>
                                                        <Form.Item>
                                                            <Row style={{ marginTop: 10 }}>
                                                                <Col span={6}>
                                                                    <div>
                                                                        Select Rating
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    {getFieldDecorator('rating', {
                                                                        initialValue: this.state.lastCallData && this.state.lastCallData.rating ? this.state.lastCallData.rating : null
                                                                    })(
                                                                        <Radio.Group value={this.state.lastCallData && this.state.lastCallData.interestedIn && this.state.lastCallData.rating ? this.state.lastCallData.rating : null} required={stage === "Open" && nextFollowUp}>
                                                                            {ratingArr.map((rating) => (
                                                                                <Radio key={rating._id} value={rating._id}>{rating.display}</Radio>
                                                                            ))}
                                                                        </Radio.Group>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Form.Item>
                                                        <Form.Item>
                                                            <Row style={{ marginTop: 10 }}>
                                                                <Col span={6}>
                                                                    <div>
                                                                        Followup Outcome
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    {getFieldDecorator('followUpType')(
                                                                        <Select required={nextFollowUp}>
                                                                            {followUpTypesArr.map((followUpType) => (
                                                                                <Option key={followUpType._id} value={followUpType.display}>{followUpType.display}</Option>
                                                                            ))}
                                                                        </Select>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Form.Item>
                                                        <Form.Item>
                                                            <Row style={{ marginTop: 10 }}>
                                                                <Col span={6}>
                                                                    <div>
                                                                        Details
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    {getFieldDecorator('detail')(
                                                                        <TextArea required={nextFollowUp} placeholder='Details' rows={5} />
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Form.Item>

                                                    </div>
                                                    : null
                                            }
                                            {/* Reassign Leads */}
                                            {
                                                stage === "Open" || stage === 'In Progress' ?
                                                    <div>
                                                        <Form.Item>
                                                            <Row style={{ marginTop: 10 }}>
                                                                <Col span={6}>
                                                                    <div>
                                                                        Re-Assign Lead
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    {getFieldDecorator('reassignLead')(
                                                                        <Checkbox defaultChecked={this.state.reassignLead} onChange={(e) => this.setState({ reassignLead: e.target.checked })} />
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Form.Item>
                                                    </div>
                                                    : null
                                            }

                                            {
                                                reassignLead ?
                                                    <div>
                                                        <Form.Item>
                                                            <Row style={{ marginTop: 10 }}>
                                                                <Col span={6}>
                                                                    <div>
                                                                        Choose Counsellor
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    {getFieldDecorator('counsellorId')(
                                                                        <Select required={reassignLead} showSearch>
                                                                            {counsellorArr.map((counsellor) => (
                                                                                <Option key={counsellor._id} value={counsellor._id}>{counsellor.display}</Option>
                                                                            ))}
                                                                        </Select>
                                                                    )}

                                                                </Col>
                                                            </Row>
                                                        </Form.Item>
                                                    </div>
                                                    : null
                                            }
                                            {
                                                stage === "Lost" ?
                                                    <div>
                                                        <Form.Item>
                                                            <Row style={{ marginTop: 10 }}>
                                                                <Col span={6}>
                                                                    <div>
                                                                        Select Reason
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    {getFieldDecorator('lostReason', {
                                                                        initialValue: this.state.lastCallData && this.state.lastCallData.lostReason ? this.state.lastCallData.lostReason : null
                                                                    })(
                                                                        <Radio.Group value={this.state.lastCallData && this.state.lastCallData.lostReason ? this.state.lastCallData.lostReason : null} required={stage === "Lost"}>
                                                                            <Radio style={radioStyle} value={"Lost to Competition"}>Lost to Competition</Radio>
                                                                            <Radio style={radioStyle} value={"Already Applied Somewhere Else"}>Already Applied Somewhere Else</Radio>
                                                                            <Radio style={radioStyle} value={"Not Interested"}>Not Interested</Radio>
                                                                            <Radio style={radioStyle} value={"Call Not Connected"}>Call Not Connected</Radio>
                                                                            <Radio style={radioStyle} value={"Not Eligible"}>Not Eligible</Radio>
                                                                            <Radio style={radioStyle} value={"Study Package"}>Study Package</Radio>
                                                                            <Radio style={radioStyle} value={"Work Visa"}>Work Visa</Radio>
                                                                            <Radio style={radioStyle} value={"Already Exists"}>Already Exists</Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Form.Item>


                                                    </div>
                                                    : null
                                            }
                                            <Form.Item>
                                                <Row style={{ marginTop: 10 }}>
                                                    <Col span={6}>
                                                        <div>
                                                            Remark
                                                        </div>
                                                    </Col>
                                                    <Col span={12}>
                                                        {getFieldDecorator('remark')(
                                                            <TextArea required={callStatus === 'Connected'} placeholder='Remarks' rows={5} />
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Form.Item>
                                        </div>
                                        : callStatus === "Not Connected" ?
                                            <div>
                                                <Form.Item>
                                                    <Row style={{ marginTop: 10 }}>
                                                        <Col span={6}>
                                                            <div>
                                                                Select Reason
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            {getFieldDecorator('notConnectedReason', {
                                                                initialValue: this.state.lastCallData && this.state.lastCallData.notConnectedReason ? this.state.lastCallData.notConnectedReason : null
                                                            })(
                                                                <Radio.Group value={this.state.lastCallData && this.state.lastCallData.notConnectedReason ? this.state.lastCallData.notConnectedReason : null} required={callStatus === "Not Connected"}>
                                                                    <Radio style={radioStyle} value={"Did Not Pick"}>Did Not Pick</Radio>
                                                                    <Radio style={radioStyle} value={"Busy in Another Call"}>Busy in Another Call</Radio>
                                                                    <Radio style={radioStyle} value={"User Disconnected the Call"}>User Disconnected the Call</Radio>
                                                                    <Radio style={radioStyle} value={"Switch Off"}>Switch Off</Radio>
                                                                    <Radio style={radioStyle} value={"Out of Coverage Area / Network Issue"}>Out of Coverage Area / Network Issue</Radio>
                                                                    <Radio style={radioStyle} value={"Call Not Connected / Call Not Be Completed"}>Call Not Connected / Call Not Be Completed</Radio>
                                                                    <Radio style={radioStyle} value={"Other Reason"}>Other Reason</Radio>
                                                                    <Radio style={radioStyle} value={"Incorrect / Invalid Number"}>Incorrect / Invalid Number</Radio>
                                                                    <Radio style={radioStyle} value={"Incoming Calls Not Available"}>Incoming Calls Not Available</Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Form.Item>
                                                <Form.Item>
                                                    <Row style={{ marginTop: 10 }}>
                                                        <Col span={6}>
                                                            <div>
                                                                Send Whatsapp Message
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            {getFieldDecorator('sendWhatsappMessage')(
                                                                <Checkbox defaultChecked={this.state.sendWhatsappMessage} onChange={(e) => this.setState({ sendWhatsappMessage: e.target.checked })} />
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Form.Item>
                                                {
                                                    sendWhatsappMessage ?
                                                        <Form.Item>
                                                            <Row style={{ marginTop: 10 }}>
                                                                <Col span={6}>
                                                                    <div>
                                                                        Select Template
                                                                    </div>
                                                                </Col>
                                                                <Col span={12}>
                                                                    {getFieldDecorator('whatsAppTemplate')(
                                                                        <Select showSearch={true}>
                                                                            {this.state.templateArr.map((template) => (
                                                                                <Option key={template.templateKey} value={template._id}>{template.templateName}</Option>
                                                                            ))}
                                                                        </Select>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Form.Item>

                                                        : null
                                                }
                                                <Form.Item>
                                                    <Row style={{ marginTop: 10 }}>
                                                        <Col span={6}>
                                                            <div>
                                                                Next Follow Up
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            {getFieldDecorator('nextFollowUp')(
                                                                <Checkbox defaultChecked={this.state.nextFollowUp} onChange={(e) => this.setState({ nextFollowUp: e.target.checked })} />
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Form.Item>

                                                {
                                                    nextFollowUp ?
                                                        <div>
                                                            <Form.Item>
                                                                <Row style={{ marginTop: 10 }}>
                                                                    <Col span={6}>
                                                                        <div>
                                                                            Next Followup Date
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={12}>
                                                                        {getFieldDecorator('followUpDate')(
                                                                            <DatePicker required={nextFollowUp} showTime format="YYYY-MM-DD" />
                                                                        )}
                                                                    </Col>
                                                                </Row>
                                                            </Form.Item>
                                                            <Form.Item>
                                                                <Row style={{ marginTop: 10 }}>
                                                                    <Col span={6}>
                                                                        <div>
                                                                            Best Time to Call
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={12}>
                                                                        {getFieldDecorator('followUpTime')(
                                                                            <TimePicker format='HH:mm' />

                                                                        )}
                                                                    </Col>
                                                                </Row>
                                                            </Form.Item>
                                                            <Form.Item>
                                                                <Row style={{ marginTop: 10 }}>
                                                                    <Col span={6}>
                                                                        <div>
                                                                            Followup Outcome
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={12}>
                                                                        {getFieldDecorator('followUpType')(
                                                                            <Select required={nextFollowUp}>
                                                                                {followUpTypesArr.map((followUpType) => (
                                                                                    <Option key={followUpType._id} value={followUpType.display}>{followUpType.display}</Option>
                                                                                ))}
                                                                            </Select>
                                                                        )}
                                                                    </Col>
                                                                </Row>
                                                            </Form.Item>
                                                            <Form.Item>
                                                                <Row style={{ marginTop: 10 }}>
                                                                    <Col span={6}>
                                                                        <div>
                                                                            Details
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={12}>
                                                                        {getFieldDecorator('detail')(
                                                                            <TextArea required={nextFollowUp} placeholder='Details' rows={5} />
                                                                        )}
                                                                    </Col>
                                                                </Row>
                                                            </Form.Item>

                                                        </div>
                                                        : null
                                                }
                                            </div>
                                            : null
                                }

                                <Row style={{ marginTop: '20px' }}>
                                    <Col span={8} />
                                    <Col span={8}>
                                        {/* <Button onClick={()=>clearInterval(this.state.intervalId)}>Save</Button> */}
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            style={{ marginBottom: 10 }}
                                            loading={this.state.loading}>
                                            Save
                                        </Button>
                                    </Col>
                                    <Col span={8} />
                                </Row>
                            </Form>
                        </TabPane>
                    </Tabs>

                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClickToCallDrawer);